import addIcon from "../../assets/images/addcircle.svg";
import deleteIcon from "../../assets/images/trash-03.svg";
import infoCircle from "../../assets/images/info-circle.svg";
import { useLocation, useNavigate } from "react-router-dom";
import TagInput from "./TagInput";
import { Modal } from "bootstrap";
import { fetchAllLanguages } from "../../action/language";
import { useEffect, useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import FilePicker from "../../components/ThumbnailPicker/FilePicker";
import uploadImage from "../../action/imageUpload";
import { addImpactStory } from "../../action/impact-story";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import showNotification from "../../components/notification/showNotification";
import { isValidAspectRatioFile } from "../../helper/helper";

const ImpactStoryAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [languages, setLanguages] = useState([]);
  const [activeLang, setActiveLang] = useState("en");

  useEffect(() => {
    fetchAllLanguages().then((res) => {
      if (res?.status) setLanguages(res.data);
    });
  }, []);

  const isValidStrictURL = (url) => {
  if (!url) return true; // optional field

  // Must start with http:// or https://
  const pattern = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;

  if (!pattern.test(url)) return false;

  try {
    new URL(url); // extra safety
    return true;
  } catch {
    return false;
  }
};

  const initialValues = {
    assets: [
      {
        title: { en: "" },
        desc: { en: "" },
        url: "",
        w: 0,
        h: 0,
        type: 2,
      },
    ],
    url: "",
    extras: {
      seo: {
        seoTitle: "",
        seoDesc: "",
        focus_keywords: [], // UI ARRAY
      },
      notification_title: {
        en: "",
        hi: "",
        mr: ""
      },
      slug:""
    },
    languages: ["en"],
  };

  const openLanguageModal = () => {
    new Modal(document.getElementById("addLanguageModal")).show();
  };

  const uploadMediaImage = async (file, index, setFieldValue) => {
    if (!file) return;

      // ✅ Detect media type
  const isVideo = file.type.startsWith("video/");
  const assetType = isVideo ? 1 : 2;
    // ✅ Aspect ratio check BEFORE upload
    if (file.type.startsWith("image/")) {
      const isValidRatio = await isValidAspectRatioFile(file);
  
      if (!isValidRatio) {
        showNotification(
          "Error",
          "Image must be in 9:16 aspect ratio (Portrait)",
          "danger"
        );
        return; // ⛔ STOP – no API call
      }
    }
     // ✅ Set asset type immediately
  setFieldValue(`assets[${index}].type`, assetType);

    const formData = new FormData();
    formData.append("file", file);
    const res = await uploadImage(formData, "gaon");
    setFieldValue(`assets[${index}].url`, res?.data?.[0] || "");
  };

  /* ---------------- API CALL ---------------- */
  const createImpactStory = async (payload) => {
    try {
      const res = await addImpactStory(payload);
      if (res?.status) {
        showNotification(
          "Success",
          res.message || "Impact Story added successfully",
          "success"
        );
        navigate("/impact-story");
      }
    } catch (error) {
      console.error("Create Impact Story Failed", error);
    }
  };

  /* ---------------- SUBMIT HANDLER ---------------- */
  const handleSubmit = async (values) => {
//URL VALIDATION (STRICT)
if (values.url && !isValidStrictURL(values.url)) {
  showNotification(
    "Error",
    "Enter a valid URL starting with http:// or https:// (e.g. https://example.com)",
    "danger"
  );
  return;
}

     // SLUG VALIDATION
if (!values.extras.slug?.trim()) {
  showNotification("Error", "Slug is required", "danger");
  return;
}

if (!/^[a-zA-Z0-9_-]+$/.test(values.extras.slug)) {
  showNotification(
    "Error",
    "Slug can only contain letters, numbers, _ and -",
    "danger"
  );
  return;
}
    // 🔴 VALIDATION
    for (let i = 0; i < values.assets.length; i++) {
      const asset = values.assets[i];

      // 1️⃣ Image validation
      if (!asset.url) {
        showNotification(
          "Error",
          `Please select image for slide ${i + 1}`,
          "danger"
        );
        return; // ⛔ STOP SUBMIT
      }

      // 2️⃣ Language-wise validation
      for (const lang of values.languages) {
        const title = asset.title?.[lang]?.trim();
        const desc = asset.desc?.[lang]?.trim();

        if (!title) {
          showNotification(
            "Error",
            `Title is required for "${getLanguageName(lang)}" in slide ${
              i + 1
            }`,
            "danger"
          );
          return; // ⛔ STOP SUBMIT
        }

        if (!desc) {
          showNotification(
            "Error",
            `Caption is required for "${getLanguageName(lang)}" in slide ${
              i + 1
            }`,
            "danger"
          );
          return; // ⛔ STOP SUBMIT
        }
      }
    }

    const payload = {
      assets: values.assets.map((a) => ({
        title: a.title,
        desc: a.desc,
        url: a.url,
        w: 0,
        h: 0,
        type: a.type,
      })),
      extras: {
        seo: {
          seoTitle: values.extras.seo.seoTitle,
          seoDesc: values.extras.seo.seoDesc,
          focus_keywords: values.extras.seo.focus_keywords.join(","),
        },
        url: values.url,
        notification_title: {
          en: values.notification_title.en,
          hi: values.notification_title.hi,
          mr: values.notification_title.mr
        },
        slug: values.extras.slug
      },
    };
    createImpactStory(payload);
  };

  const getLanguageName = (code) =>
    languages.find((l) => l.shortCode === code)?.name || code.toUpperCase();

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ values, setFieldValue }) => {
        if (!values.languages.includes(activeLang)) setActiveLang("en");

        const availableLanguages = languages.filter(
          (l) => !values.languages.includes(l.shortCode)
        );

        return (
          <Form>
            <div className="pagecolwrap">
              {/* HEADER */}
              <div className="payout_data-head">
                <div className="payout_data-head-top">
                  <div className="payout_data-left">
                    <div className="payout_data_ttl">
                      <Breadcrumb
                        paths={[
                          {
                            name: "Impact Stories",
                            link: `/impact-story`,
                            state: location.state,
                          },
                          {
                            name: "Add Impact Story",
                            link: "/impact-story/add",
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Add
                  </button>
                </div>
              </div>
              {/* <div className="payout_data-head-top">
                <div className="payout_data-left p-0">
                  <div className="payout_data_ttl1">Add New Impact Story</div>
                </div>
                <button type="submit" className="btn btn-primary">
                  Save
                </button>
              </div> */}

              <div className="row">
                {/* LEFT */}
                <div className="col-md-8">
                  <FieldArray name="assets">
                    {({ push, remove }) => (
                      <>
                        {values.assets.map((asset, index) => (
                          <div key={index} className="payout_data-content mb-3">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="h-100 d-flex flex-column justify-content-center">
                                  <label className="input-label">image</label>

                                  <FilePicker
                                    width="100%"
                                    height="250px"
                                    image={asset.url}
                                    accept="image/*,video/*"
                                    onFileSelect={(file) =>
                                      uploadMediaImage(
                                        file,
                                        index,
                                        setFieldValue
                                      )
                                    }
                                  />
                                  <small className="text-muted">
                                    Allowed image ratio: 9:16 (Portrait)
                                  </small>
                                </div>
                              </div>
                              <div className="col-md-8">
                                <div className="input-box mt-0">
                                  <label className="input-label">
                                    Title ({getLanguageName(activeLang)})
                                    <span>*</span>
                                  </label>
                                  <div className="input_field">
                                    <Field
                                      key={`title-${index}-${activeLang}`}
                                      name={`assets[${index}].title.${activeLang}`}
                                      className="input"
                                      placeholder="Enter title"
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="input-box">
                                  <label className="input-label">
                                    Caption ({getLanguageName(activeLang)})
                                    <span>*</span>
                                  </label>
                                  <div className="input_field">
                                    <Field
                                      key={`desc-${index}-${activeLang}`}
                                      as="textarea"
                                      rows={5}
                                      name={`assets[${index}].desc.${activeLang}`}
                                      className="input"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              {values.assets.length > 1 && (
                                <button
                                  type="button"
                                  className="delete-btn mt-2"
                                  onClick={() => remove(index)}
                                >
                                  <img src={deleteIcon} alt="" />
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                        <div className="addsec">
                          <button
                            type="button"
                            className="delete-btn"
                            onClick={() =>
                              push({
                                title: Object.fromEntries(
                                  values.languages.map((l) => [l, ""])
                                ),
                                desc: Object.fromEntries(
                                  values.languages.map((l) => [l, ""])
                                ),
                                url: "",
                                w: "",
                                h: "",
                                type: 2,
                              })
                            }
                          >
                            <img src={addIcon} alt="" /> Add New
                          </button>
                        </div>
                      </>
                    )}
                  </FieldArray>
                </div>

                {/* RIGHT */}
                <div className="col-md-4">
                  <div className="payout_data-content mb-3">
                    <h4>General Details</h4>
                    <div className="input-box mt-0 mb-2">
                      <label className="input-label">Redirect URL</label>
                      <div className="input_field">
                        <Field
                          name="url"
                          className="input"
                          placeholder="ie. www.example.com"
                        />
                      </div>
                    </div>
                    <div className="input-box">
                      <label className="input-label">Slug
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Slug should contains person name, gaon and story title"
                      />
                      </label>
                      <div className="input_field">
                      <Field name="extras.slug">
                          {({ field, form }) => (
                            <input
                              {...field}
                              className="input"
                              placeholder="Enter slug"
                              onChange={(e) => {
                                const value = e.target.value
                                  .replace(/[^a-zA-Z0-9_-]/g, "") // allow only a-z A-Z 0-9 _ -
                                  .toLowerCase();

                                form.setFieldValue("extras.slug", value);
                              }}
                              required
                            />
                          )}
                        </Field>
                      </div>
                    </div>
                  </div>

                  <div className="payout_data-content mb-3">
                    <h4>Notification Title</h4>
                    <div className="input-box">
                      <label className="input-label">English Title</label>
                      <div className="input_field">
                        <Field
                          name="notification_title.en"
                          className="input"
                          placeholder="Enter English Title"
                          required
                        />
                      </div>
                    </div>
                    <div className="input-box">
                      <label className="input-label">Hindi Title</label>
                      <div className="input_field">
                        <Field
                          name="notification_title.hi"
                          className="input"
                          placeholder="Enter Hindi Title"
                          required={values.assets.some(a => a?.desc?.hi?.trim() || a?.title?.hi?.trim() )}
                        />
                      </div>
                    </div>
                    <div className="input-box">
                      <label className="input-label">Marathi Title</label>
                      <div className="input_field">
                        <Field
                          name="notification_title.mr"
                          className="input"
                          placeholder="Enter Marathi Title"
                          required={values.assets.some(a => a?.desc?.mr?.trim() || a?.title?.mr?.trim())}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="payout_data-content mb-3">
                    <h4>SEO</h4>
                    <div className="input-box mt-0">
                      <label className="input-label">Focus Keywords</label>
                      <TagInput
                        value={values.extras.seo.focus_keywords}
                        onChange={(tags) =>
                          setFieldValue("extras.seo.focus_keywords", tags)
                        }
                      />
                    </div>
                    <div className="input-box">
                      <label className="input-label">SEO Title</label>
                      <div className="input_field">
                        <Field
                          name="extras.seo.seoTitle"
                          className="input"
                          placeholder="Enter SEO Title"
                        />
                      </div>
                    </div>
                    <div className="input-box">
                      <label className="input-label">SEO Description</label>
                      <div className="input_field">
                        <Field
                          name="extras.seo.seoDesc"
                          className="input"
                          placeholder="Enter SEO Description"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="payout_data-content mb-3">
                    <h4>Region Specific Content</h4>

                    <div className="langbx">
                      {values.languages.map((lang) => (
                        <div
                          key={lang}
                          className={`langbx-item ${
                            activeLang === lang ? "active" : ""
                          }`}
                          onClick={() => setActiveLang(lang)}
                        >
                          {lang.toUpperCase()}
                          {lang !== "en" && (
                            <img
                              src={deleteIcon}
                              className="delpos"
                              alt=""
                              onClick={(e) => {
                                e.stopPropagation();

                                setFieldValue(
                                  "languages",
                                  values.languages.filter((l) => l !== lang)
                                );

                                values.assets.forEach((_, i) => {
                                  setFieldValue(
                                    `assets[${i}].title.${lang}`,
                                    undefined
                                  );
                                  setFieldValue(
                                    `assets[${i}].desc.${lang}`,
                                    undefined
                                  );
                                });

                                setActiveLang("en");
                              }}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                    <div className="addsec mt-4">
                      <button
                        type="button"
                        className="delete-btn"
                        style={{ color: "#0073ffff" }}
                        onClick={openLanguageModal}
                      >
                        <img src={addIcon} alt="" /> Add Language
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* LANGUAGE MODAL */}
            <div
              className="modal fade"
              id="addLanguageModal"
              tabIndex="-1"
              aria-labelledby="addLanguageModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  {/* Header */}
                  <div className="modal-header">
                    <h4 id="addLanguageModalLabel">Add Language</h4>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  {/* Body */}
                  <div className="modal-body">
                    <div className="input-box mt-0">
                      {availableLanguages.length === 0 ? (
                        <p className="text-center text-muted">
                          All languages selected
                        </p>
                      ) : (
                        <>
                          <label className="input-label">
                            Language Name <span>*</span>
                          </label>
                          <div className="input_field">
                            <select
                              className="input"
                              onChange={(e) => {
                                const lang = e.target.value;
                                if (!lang) return;

                                setFieldValue("languages", [
                                  ...values.languages,
                                  lang,
                                ]);

                                values.assets.forEach((_, i) => {
                                  setFieldValue(
                                    `assets[${i}].title.${lang}`,
                                    ""
                                  );
                                  setFieldValue(
                                    `assets[${i}].desc.${lang}`,
                                    ""
                                  );
                                });

                                setActiveLang(lang);
                              }}
                            >
                              <option value="">Choose language</option>
                              {availableLanguages.map((l) => (
                                <option key={l.shortCode} value={l.shortCode}>
                                  {l.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  {/* Footer */}
                  {/* <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button type="button" className="btn btn-primary">
                      Save
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ImpactStoryAdd;
